import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LOCALE_ID } from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { InputNumberModule } from 'primeng/inputnumber';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';
import { LocalStorageModule } from 'angular-2-local-storage';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { MenuNavBarComponent } from './theme/layout/admin/menu-nav-bar/menu-nav-bar.component';
import { MenuDropdownNavBarComponent } from './theme/layout/admin/menu-dropdown-nav-bar/menu-dropdown-nav-bar.component';
import { PageMenuComponent } from './theme/layout/admin/page-menu/page-menu.component';
import { BreadcrumbComponent } from './theme/layout/admin/breadcrumb/breadcrumb.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import { Ng5SliderModule } from 'ng5-slider';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { NgChartsModule } from 'ng2-charts';
import { ModalModule } from 'ngx-bootstrap/modal';
import { KtdGridModule } from '@katoid/angular-grid-layout';
import { PageHomeModule } from './cms/menu/page-home/page-home.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';

registerLocaleData(localeEs);
@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    ConfigurationComponent,
    AuthComponent,
    NavBarComponent,
    MenuNavBarComponent,
    MenuDropdownNavBarComponent,
    PageMenuComponent,
    BreadcrumbComponent,
    NavRightComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    PageHomeModule,
    KtdGridModule,
    BrowserModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    BrowserAnimationsModule,
    Ng5SliderModule,
    LocalStorageModule.forRoot({
      prefix: 'AdminImplementos',
      storageType: 'localStorage',
    }),
    NgChartsModule,
    InputNumberModule,
    InputTextModule,
    ToastModule,
  ],
  providers: [
    DatePipe,
    {
      provide: LOCALE_ID,
      useValue: 'es-ES',
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
